<template>
  <div v-if="visible" class="hcp-adhd-overlay" @click.self="close">
    <div class="hcp-adhd-card">
      <button class="hcp-adhd-close" @click="close" aria-label="Close modal">&#x2715;</button>
      <div class="hcp-adhd-image-wrap" @click="close">
        <picture>
          <source media="(min-width: 768px)" :srcset="desktopImage" />
          <img :src="mobileImage" alt="ADHD Awareness Month HCP Interstitial" class="hcp-adhd-img" />
        </picture>
      </div>
    </div>
  </div>
</template>

<script>
import desktopImg from '@/assets/img/modal/JNY-HCP-desk_0785.jpg';
import mobileImg from '@/assets/img/modal/JNY-HCP-mobile_0785.jpg';
import { releaseState, releaseBus } from '@/utils/releaseManager';

const SESSION_KEY = 'jny_hcp_adhd_oct_seen';

export default {
  name: 'HcpAdhdPopup',
  data() {
    return {
      visible: false,
      desktopImage: desktopImg,
      mobileImage: mobileImg
    };
  },
  computed: {
    isOct1Active() {
      return releaseState.isOct1Active;
    }
  },
  mounted() {
    this.checkVisibility();

    // Re-check visibility when HCP gate is accepted
    this.$root.$on('modal', (action) => {
      if (action === 'accept') {
        this.checkVisibility();
      }
    });

    // Listen for manual trigger from Settings drawer or preview buttons
    releaseBus.$on('trigger-oct-popup', this.showManual);
    releaseBus.$on('release-mode-changed', this.checkVisibility);
  },
  beforeDestroy() {
    releaseBus.$off('trigger-oct-popup', this.showManual);
    releaseBus.$off('release-mode-changed', this.checkVisibility);
    document.body.classList.remove('hcp-modal-open');
  },
  methods: {
    checkVisibility() {
      const isHcpAccepted = localStorage.getItem('journayhcpmodalacepted') === 'true';
      if (isHcpAccepted && this.isOct1Active && !sessionStorage.getItem(SESSION_KEY)) {
        this.visible = true;
        document.body.classList.add('hcp-modal-open');
      } else if (!this.isOct1Active && this.visible) {
        this.visible = false;
        document.body.classList.remove('hcp-modal-open');
      }
    },
    showManual() {
      this.visible = true;
      document.body.classList.add('hcp-modal-open');
    },
    close() {
      sessionStorage.setItem(SESSION_KEY, '1');
      this.visible = false;
      document.body.classList.remove('hcp-modal-open');
    }
  }
};
</script>

<style scoped>
.hcp-adhd-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  animation: fadeIn 0.25s ease-out;
}

.hcp-adhd-card {
  position: relative;
  width: 100%;
  max-width: 703px;
  background: transparent;
  border-radius: 8px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.45);
  overflow: hidden;
  cursor: pointer;
}

.hcp-adhd-close {
  position: absolute;
  top: 3.78%;
  right: 4.27%;
  width: 5.55%;
  height: 7.75%;
  background: transparent;
  border: none;
  border-radius: 50%;
  color: transparent;
  font-size: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  padding: 0;
  opacity: 0;
  outline: none;
  transition: opacity 0.2s ease;
}

.hcp-adhd-close:focus-visible {
  opacity: 1;
  border: 2px solid #fff;
  background: rgba(0, 0, 0, 0.2);
}

@media (max-width: 767px) {
  .hcp-adhd-card {
    max-width: 360px;
    max-height: 90vh;
  }

  .hcp-adhd-close {
    top: 2.29%;
    right: 6.53%;
    width: 10.56%;
    height: 5.8%;
  }
}

.hcp-adhd-image-wrap {
  width: 100%;
  display: block;
}

.hcp-adhd-img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
